import { isEmail } from 'Utils/Validators/email'

export function validate(values) {
  const errors = {}

  if (!values.username) {
    errors.username = 'Required'
  } else if (!isEmail(values.username)) {
    errors.username = 'This username is incorrect'
  }

  if (!values.password) {
    errors.password = 'Required'
  }

  return errors
}



// WEBPACK FOOTER //
// ./src/Containers/Form/Login/validate.js